module.exports = __webpack_public_path__ + "img/KA.e429497b.jpg";